import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import FoodSearch from '../../components/food/search/index'
import { FOOD_STATUS } from '../../constants'
import { getFoodGroup } from '../../selectors'
import { ensureArray, matchFood } from '../../utils/helper'
import { getActionViewFood } from '../../utils/view'

const SearchBoxContainer = props => {
    const dispatch = useDispatch()
    const history = useHistory()
    const foodsGrouped = useSelector(state => state.FoodReducer)
    const foodGroupInfo = useSelector(getFoodGroup)

    const [showBoxSearch, setShowBoxSearch] = useState(false)
    const [keyword, setKeyword] = useState('')

    const listFood = foodGroupInfo.reduce((rs, groupInfo) => {
        const list = (foodsGrouped[groupInfo.id] || []).filter(f => f.status !== FOOD_STATUS.SOLD_OUT);
        return [...rs, ...list];
    }, []);

    const handleKeywordChange = key => {
        setKeyword(key)
    }

    const handleSetFoodSelected = food => {
        dispatch(getActionViewFood(food))
    }

    const onSelectFood = food => {
        setKeyword('')
        setShowBoxSearch(false)
        handleSetFoodSelected(food)
    }

    useEffect(() => {
        if (!showBoxSearch) {
            setKeyword('')
            // handleSetFoodSelected(null)
        }
    }, [showBoxSearch])

    useEffect(() => {
        keyword && setKeyword('')
        showBoxSearch && setShowBoxSearch(false)
    }, [history.location.pathname])

    return (
        <FoodSearch
            keyword={keyword}
            setKeyword={handleKeywordChange}
            listFood={ensureArray(listFood).filter(f => matchFood(keyword, f))}
            showBoxSearch={showBoxSearch}
            setShowBoxSearch={setShowBoxSearch}
            onSelectFood={onSelectFood}
        />
    )
}

export default SearchBoxContainer
